import React, { useState, useEffect } from 'react';
import { useLang } from '../../hooks/useLang';

const FontSizeToggle = () => {
    const { t } = useLang();
    const [isLargeText, setIsLargeText] = useState(false);

    useEffect(() => {
        if (isLargeText) {
            document.body.classList.add('large-text');
        } else {
            document.body.classList.remove('large-text');
        }
    }, [isLargeText]);

    const toggleFontSize = () => {
        setIsLargeText(!isLargeText);
    };

    return (
        <button
            type="button"
            onClick={toggleFontSize}
            className={`btn-floating-control ${isLargeText ? 'active-state' : ''}`}
            aria-label={isLargeText ? t('controls.font.restore') : t('controls.font.increase')}
            title={isLargeText ? t('controls.font.normal') : t('controls.font.increase')}
            style={{ fontWeight: '800', fontSize: '1.1rem' }}
        >
            {isLargeText ? 'A-' : 'A+'}
        </button>
    );
};

export default FontSizeToggle;

